export default `-----BEGIN PUBLIC KEY-----
MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEnkH59p7GD3e1QcMrWTG2CDb0pBz0
dTJ8f00ESLc0gJOVP9gCVA1uqFMkcJBMKtXWHpKYAhf2q/VgdvCm4czICA==
-----END PUBLIC KEY-----`;
